import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import type { NotificationPreferenceListItem } from "@msuite/utils/types";
import { NotificationChannelCell } from "./notification-channel-cell";

/** One row of the table: a catalogue kind, keyed by itself. */
export type NotificationPreferenceRow = NotificationPreferenceListItem & { id: string };

const columnHelper = createColumnHelper<NotificationPreferenceRow>();

/** Props Interface */
interface CreateColumnsOptions {
	/** The account has an address; without one the mail checkboxes cannot be turned on. */
	hasEmail: boolean;
}

/**
 * The table's columns: the group the rows are grouped by (hidden), the kind with its description,
 * and one checkbox column per channel. Built per render so the headers follow a language switch.
 */
export function createColumns({ hasEmail }: CreateColumnsOptions) {
	return [
		columnHelper.accessor("group", {
			id: "group",
			header: localized("notifications.preferences.title"),
		}),
		columnHelper.accessor("label", {
			id: "kind",
			header: localized("notifications.preferences.title"),
			size: 360,
			cell: (cell) => (
				<div className="v-stack gap-0! min-w-0 py-1">
					<p className="truncate">{localized(cell.row.original.label)}</p>
					<p className="label whitespace-normal">{localized(cell.row.original.description)}</p>
				</div>
			),
		}),
		columnHelper.display({
			id: "push",
			header: localized("notifications.preferences.push"),
			cell: (cell) => (
				<NotificationChannelCell
					item={cell.row.original}
					channel="push"
					isDisabled={false}
				/>
			),
		}),
		columnHelper.display({
			id: "email",
			header: localized("notifications.preferences.email"),
			cell: (cell) => (
				<NotificationChannelCell
					item={cell.row.original}
					channel="email"
					isDisabled={!hasEmail}
				/>
			),
		}),
	];
}
